/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Ladda = require('ladda');

var SideNavSectionView = require('common/views/SideNavSectionView');
var openInNewTab = require('common/util/openInNewTab');

var DepFilingPointOfContactSectionView = require('../../views/DepFilingPointOfContactSectionView');
var DepFilingLawyerSectionView = require('../../views/DepFilingLawyerSectionView');

var tmplDepMobileBranchFilingView = require('./DepMobileBranchFilingView.hbs');
var SubmitMobileBranchFiling = require('../../services/SubmitMobileBranchFiling');
var DepMobileBranchSubmissionSectionView = require('./DepMobileBranchSubmissionSectionView');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepMobileBranchFilingView,

  className: 'dep-mobile-branch-filing-view m-b-md',

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  ui: {
    filingSections: '.filing-sections',
    nextButton: '.next-button',
    previousButton: '.previous-button'
  },

  events: {
    'click @ui.previousButton': 'onClickPrevious',
    'click @ui.nextButton': 'onClickNext'
  },

  regions: {
    filingSections: '@ui.filingSections'
  },

  onBeforeShow: function() {
    var filingDetails = this.model.get('filingDetails') || {};
    var filingContent = this.model.get('filingContent') || {};
    var filingId = this.model.get('filingId');
    var lawyers = this.model.get('lawyers') || filingDetails.lawyers;
    var pointOfContact = filingDetails.pointOfContact;
    var mode = this.options.mode;
    var isNewExternal = mode === 'ext-new';
    var isNewInternal = mode === 'int-new';
    var isForPrinting = mode === 'print';
    var isExpandInternal = mode === 'int-expand';

    this.form = new SideNavSectionView({
      collection: new Backbone.Collection([
        {
          id: 'mobileBranchPointOfContact',
          title: 'Point of Contact',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new DepFilingPointOfContactSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            hasAddress: true,
            model: new Backbone.Model(pointOfContact)
          })
        },
        {
          id: 'mobileBranchLawyer',
          title: 'Filer',
          view: new DepFilingLawyerSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({
              lawyers: lawyers,
              currentLawyer: filingDetails.lawyer
            })
          })
        },
        {
          id: 'mobileBranchSubmission',
          title: 'Submission',
          showRequiredFieldDisclaimer: !this.options.isReadOnly,
          view: new DepMobileBranchSubmissionSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({
              filingDetails: filingDetails,
              filingContent: filingContent,
              filingId: filingId
            })
          })
        }
      ]),
      useNavigationButtons: false,
      expanded: isForPrinting || isExpandInternal,
      contentWidth: 'medium',
      useNavigationSavePrevButtons: !this.options.isReadOnly,
      buttons: [
        {
          buttonText: 'Save',
          buttonClass: 'btn-default ladda-button',
          buttonIconClass: 'fa-save',
          labelClass: 'ladda-label',
          buttonAttrs: {
            'data-style': 'expand-right'
          },
          onClick: this.onClickSave.bind(this)
        },
        {
          buttonText: 'Save & Print',
          buttonClass: 'btn-default ladda-button',
          buttonIconClass: 'fa-print',
          labelClass: 'ladda-label',
          buttonAttrs: {
            'data-style': 'expand-right'
          },
          onClick: this.onClickPrint.bind(this)
        }
      ]
    });

    // If this isn't the new external form, or if the form is in print mode, remove the buttons
    if (!(isNewExternal || isNewInternal) || isForPrinting) {
      this.form.options.buttons = [];
    }
    this.showChildView('filingSections', this.form);
  },

  onClickNext: function(e) {
    var l = Ladda.create(e.currentTarget);
    l.start();

    this.saveForm()
      .done(function() {
        l.stop();
      })
      .fail(function() {
        l.stop();
      });
    window.scrollTo(0, 0);
  },

  onClickPrevious: function(e) {
    var l = Ladda.create(e.currentTarget);
    l.start();

    this.saveForm()
      .done(function() {
        l.stop();
      })
      .fail(function() {
        l.stop();
      });
    window.scrollTo(0, 0);
  },

  onClickSave: function(e) {
    var l = Ladda.create(e.currentTarget);
    l.start();

    this.saveForm()
      .done(function() {
        l.stop();
      })
      .fail(function() {
        l.stop();
      });
  },

  onClickPrint: function(e) {
    var filingId = this.model.get('filingId');
    var l = Ladda.create(e.currentTarget);
    l.start();

    this.saveForm()
      .done(function() {
        openInNewTab('#ext/dep/filing/' + filingId + '/print');
        l.stop();
      })
      .fail(function() {
        l.stop();
      });
  },

  saveForm: function() {
    var deferred = $.Deferred();
    var self = this;
    var filingId = this.model.get('filingId');

    this.form
      .validateAll({ type: 'save' })
      .done(function() {
        var formData = self.form.getFormData();
        formData.filingId = filingId;

        SubmitMobileBranchFiling(formData)
          .done(function() {
            deferred.resolve();
          })
          .fail(function() {
            deferred.reject();
          });
      })
      .fail(function() {
        deferred.reject();
      });
    return deferred.promise();
  }
});
